export function formatIBAN(v: string): string {
  return (v.match(/.{1,4}/g)?.join(' ') ?? v).toUpperCase();
}
